"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BOIWhiteLogo = require("./BOIWhiteLogo");

var _BOIWhiteLogo2 = _interopRequireDefault(_BOIWhiteLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BOIWhiteLogo2.default;